webpackJsonp([109397924264480],{

/***/ 265:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var BoardOfDirectorsPage = function BoardOfDirectorsPage(props) {
	    var bod = ['Thomas Alston', 'Joey Burrough', 'Matt Glover', 'Linda Harris', 'Randy Holmes', 'Wayne Kish', 'Kenneth Marks', 'Dave Riley', 'Peter Rochelle', 'Madi Smith', 'Spencer Tilley', 'Scott Ziegler'];
	
	    return _react2.default.createElement(
	        'div',
	        { className: 'staticPage' },
	        _react2.default.createElement(
	            'h1',
	            null,
	            'YCFC Board of Directors'
	        ),
	        _react2.default.createElement(
	            'ul',
	            { className: 'bodList' },
	            bod.map(function (member) {
	                return _react2.default.createElement(
	                    'p',
	                    { key: member },
	                    member
	                );
	            })
	        )
	    );
	};
	
	exports.default = BoardOfDirectorsPage;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-board-of-directors-js-a6d4548e1ba4b93670ce.js